import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import store, { persistor, SET_TOKEN, SET_LOADER, DELETE_LOADER } from '../../store';
import reissue from '../auth-account/reissue';

// ----------------------------------------------------------------------

const instance = axios.create({
  baseURL: '/api/'
});

instance.interceptors.request.use(async (config) => {
  store.dispatch( SET_LOADER() );
  const token = store.getState().token;
  config.headers.Authorization = 'Bearer ' + token;
  return config;
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const config = error.config;
    const code = error.response.data.code;

    if ( ( config.url === 'accounts/me' && code === 'ERR-001' ) || code === 'ERR-003' ) {
      await reissue()
        .catch((error) => {
          return Promise.reject(error);
        });
      const token = store.getState().token;
      config.headers.Authorization = 'Bearer ' + token;
      return axios(config);
    } else {
      return Promise.reject(error);
    }
  }
);

// ----------------------------------------------------------------------

export const customAxios = (
  config: AxiosRequestConfig,
  resolve: ( response: AxiosResponse<any, any> ) => void,
  reject: ( error: unknown ) => void
) => {
  instance.request(config)
    .then((response) => {
      return resolve(response);
    })
    .catch((error) => {
      const code = error.response.data.code;
      
      if ( error.code === 'ERR_BAD_RESPONSE' ) {
        persistor.purge();
        return window.location.href = '/alert';
      } else if ( code === 'ERR-001' || code === 'ERR-REISSUE' ) {
        persistor.purge();
        return window.location.href = '/login';
      } else {
        return reject(error);
      }
    })
    .finally(() => {
      store.dispatch(
        DELETE_LOADER()
      );
    });
};

// ----------------------------------------------------------------------

export default instance;